import { Mixin } from 'ts-mixer';
import { always } from 'ramda';
import { ObjectElement } from '@swagger-api/apidom-core';
import { MapVisitor, FallbackVisitor } from '@swagger-api/apidom-ns-openapi-3-1';

/**
 * @public
 */

/**
 * @public
 */
class AdditionalOperationsVisitor extends Mixin(MapVisitor, FallbackVisitor) {
  constructor(options) {
    super(options);
    this.element = new ObjectElement();
    this.specPath = always(['document', 'objects', 'Operation']);
  }
}
export default AdditionalOperationsVisitor;